import { createRoute } from "@tanstack/react-router";

import { requirePermission } from "@platform/auth/guards";
import { shellRoute } from "@platform/shell.route";
import { UsagePage } from "./usage.page";

export const usageRoute = createRoute({
	getParentRoute: () => shellRoute,
	path: "/usage",
	beforeLoad: ({ context }) => requirePermission(context.queryClient, { usage: ["read"] }),
	component: UsagePage,
});
